










import Vue from "vue";
import Component from "vue-class-component";
import { PromocaoService } from "@/services/promocao.service";
import { Prop, Watch } from "vue-property-decorator";
import { requiredValidZero } from "@/shared/validators";

interface ComboItem {
  text: string;
  value: number;
}

@Component
export default class ComboStatus extends Vue {
  @Prop(Number) value!: number | undefined;

  @Watch("tipo")
  onChangeTipo(val: ComboItem) {
    this.$emit("input", val?.value);
  }

  rules = {
    tipo: [requiredValidZero()],
  };

  valid = false;
  tipo: ComboItem | null = null;
  itemsTipo: ComboItem[] = [];
  array: ComboItem[] = [];
  loading = false;

  async fetchStatus() {
    this.loading = true;
    const res = await PromocaoService.ListarStatusPromocao();

    this.array = Object.values(res);

    this.itemsTipo = this.array.map((x, i) => ({
      text: x + "",
      value: i,
    }));

    if (this.value) {
      this.tipo = this.itemsTipo.find((x) => x.value == this.value) || null;
    }

    this.loading = false;
  }

  mounted() {
    this.fetchStatus();
  }
}
